import React from 'react';

import { WidgetProps } from 'components/Visualization/CDashboard/types';

import { CloudEventsSummaryState } from '../../../types';

import { APICalls } from './APICalls';
import { APICallsByActionTypes } from './APICallsByActionTypes';
import { DataAccessed } from './DataAccessed';
import { InsightsSummary } from './InsightsSummary';

export const getCloudEventsSummaryWidgets = (
  summary: CloudEventsSummaryState,
  isHourly = false,
  summaryPeriod?: string,
): Record<string, WidgetProps> => ({
  apiCallsByActionType: {
    flex: true,
    components: {
      content: (
        <APICallsByActionTypes
          summary={summary}
          isHourly={isHourly}
          summaryPeriod={summaryPeriod}
        />
      ),
    },
  },
  dataAccessed: {
    flex: true,
    components: {
      content: (
        <DataAccessed
          summary={summary}
          isHourly={isHourly}
          summaryPeriod={summaryPeriod}
        />
      ),
    },
  },
  apiCalls: {
    flex: true,
    components: {
      content: (
        <APICalls
          summary={summary}
          isHourly={isHourly}
          summaryPeriod={summaryPeriod}
        />
      ),
    },
  },
  insights: {
    flex: true,
    components: {
      content: (
        <InsightsSummary
          summary={summary}
          isHourly={isHourly}
          summaryPeriod={summaryPeriod}
        />
      ),
    },
  },
});
